/* TiltMark storefront scripts */
(function(){
  'use strict';
  var money=function(cents){
    var fmt=(window.TM&&TM.moneyFormat)||'${{amount}}';
    var v=(cents/100).toFixed(2);
    var parts=v.split('.');var withComma=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/,withComma).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,parts[0]+','+parts[1]).replace(/\{\{\s*amount\s*\}\}/,withComma+'.'+parts[1]);
  };

  /* ---------- reveal on scroll ---------- */
  function initReveal(root){
    var els=(root||document).querySelectorAll('.tm-reveal:not(.tm-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('tm-in')});return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('tm-in');io.unobserve(en.target);}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e){io.observe(e)});
  }

  /* ---------- lazy autoplay videos ---------- */
  function initVideos(root){
    var vids=(root||document).querySelectorAll('video[data-tm-autoplay]');
    if(!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(entries){entries.forEach(function(en){var v=en.target;
      if(en.isIntersecting){ if(v.dataset.src&&!v.src){v.src=v.dataset.src;} var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
      else{ v.pause(); }
    })},{threshold:.25});
    vids.forEach(function(v){io.observe(v)});
  }

  /* ---------- cart helpers ---------- */
  function sectionIds(){
    var ids=[];var d=document.querySelector('cart-drawer');var n=document.querySelector('cart-notification');
    if(d&&d.getSectionsToRender){d.getSectionsToRender().forEach(function(s){ids.push(s.id)})}
    else if(n&&n.getSectionsToRender){n.getSectionsToRender().forEach(function(s){ids.push(s.id)})}
    return ids;
  }
  function addItems(items){
    var ids=sectionIds();
    var body={items:items};
    if(ids.length){body.sections=ids;body.sections_url=window.location.pathname;}
    return fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json().then(function(j){if(!r.ok||j.status){throw new Error(j.description||j.message||'Could not add to cart')}return j;})});
  }
  function showCart(res){
    var d=document.querySelector('cart-drawer');var n=document.querySelector('cart-notification');
    try{
      if(d&&d.renderContents&&res.sections){
        var first=res.items&&res.items[0]?res.items[0]:{};
        res.id=first.key||first.id; d.classList.remove('is-empty'); d.renderContents(res); return;
      }
      if(n&&n.renderContents&&res.sections){var f=res.items&&res.items[0]?res.items[0]:{};res.key=f.key;n.renderContents(res);return;}
    }catch(e){}
    window.location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart';
  }

  /* ---------- product form ---------- */
  function initPDP(el){
    var data;try{data=JSON.parse(el.querySelector('[data-tm-product-json]').textContent)}catch(e){return}
    var variants=data.variants;var opts=data.options;
    var sel=(data.selected||variants[0].options).slice();
    var qty=1;try{var qp=+new URLSearchParams(window.location.search).get('qty');if(qp===2||qp===3)qty=qp;}catch(e){}var disc={1:0,2:data.d2||10,3:data.d3||15};
    var priceEl=el.querySelector('[data-tm-price]');var msg=el.querySelector('[data-tm-msg]');
    var atc=el.querySelectorAll('[data-tm-atc]');var buy=el.querySelectorAll('[data-tm-buy]');
    var mainImg=el.querySelector('[data-tm-main]');
    var stickyT=document.querySelector('[data-tm-sticky-title]');

    function current(){return variants.find(function(v){return v.options.every(function(o,i){return o===sel[i]})})}
    function availableFor(idx,val){var t=sel.slice();t[idx]=val;return variants.some(function(v){return v.available&&v.options.every(function(o,i){return o===t[i]})})}
    function setMsg(t){if(!msg)return;msg.textContent=t||'';msg.classList.toggle('is-on',!!t)}
    function showMedia(id,src){
      if(!mainImg)return;
      var btn=el.querySelector('[data-tm-thumb][data-id="'+id+'"]');
      if(btn){btn.click();return;}
      if(src){mainImg.innerHTML='<img src="'+src+'" alt="">';}
    }
    function render(){
      var v=current();
      el.querySelectorAll('[data-tm-opt]').forEach(function(b){
        var i=+b.dataset.idx;var val=b.dataset.value;
        b.classList.toggle('is-active',sel[i]===val);
        b.classList.toggle('is-out',!availableFor(i,val));
      });
      el.querySelectorAll('[data-tm-opt-current]').forEach(function(s){s.textContent=sel[+s.dataset.idx]});
      var unit=v?v.price:variants[0].price;
      if(priceEl)priceEl.textContent=money(unit);
      el.querySelectorAll('[data-tm-bundle]').forEach(function(b){
        var q=+b.dataset.q;var d=disc[q]||0;var full=unit*q;var now=Math.round(full*(100-d)/100);
        b.querySelector('[data-tm-bp]').innerHTML=money(now)+(d?'<s>'+money(full)+'</s>':'');
        b.classList.toggle('is-active',q===qty);
        var r=b.querySelector('input');if(r)r.checked=(q===qty);
      });
      var pairPrice=el.querySelector('[data-tm-pair-price]');
      if(pairPrice){var full2=unit*2;pairPrice.innerHTML=money(Math.round(full2*(100-disc[2])/100))+' <s style="opacity:.6">'+money(full2)+'</s>';}
      var ok=!!(v&&v.available);
      atc.forEach(function(b){b.disabled=!ok;var l=b.querySelector('[data-label]');if(l)l.textContent=ok?(qty>1?('Add '+qty+' to cart'):'Add to cart'):'Sold out'});
      buy.forEach(function(b){b.disabled=!ok});
      if(stickyT&&v){stickyT.innerHTML=data.title+'<span>'+v.title+' · '+money(unit)+'</span>';}
      if(v&&window.history&&history.replaceState){var u=new URL(window.location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u.toString());}
    }
    el.addEventListener('click',function(e){
      var o=e.target.closest('[data-tm-opt]');
      if(o){sel[+o.dataset.idx]=o.dataset.value;render();
        if(o.dataset.media){showMedia(o.dataset.media)}
        setMsg('');return;}
      var b=e.target.closest('[data-tm-bundle]');
      if(b){qty=+b.dataset.q;render();return;}
      var t=e.target.closest('[data-tm-thumb]');
      if(t&&mainImg){
        el.querySelectorAll('[data-tm-thumb]').forEach(function(x){x.classList.remove('is-active')});t.classList.add('is-active');
        var tpl=t.querySelector('template');if(tpl){mainImg.querySelectorAll('img,video').forEach(function(n){n.remove()});mainImg.insertBefore(tpl.content.cloneNode(true),mainImg.firstChild);initVideos(mainImg)}
        return;}
    });
    function go(btn,toCheckout,items){
      var v=current();if(!v||!v.available){setMsg('Please choose an available option.');return}
      items=items||[{id:v.id,quantity:qty}];
      btn.classList.add('is-loading');btn.disabled=true;setMsg('');
      addItems(items).then(function(res){
        if(toCheckout){window.location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'checkout';return}
        showCart(res);
      }).catch(function(err){setMsg(err.message)}).finally(function(){btn.classList.remove('is-loading');btn.disabled=false;});
    }
    atc.forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();go(b,false)})});
    buy.forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();go(b,true)})});
    var pair=el.querySelector('[data-tm-pair]');
    if(pair){pair.addEventListener('click',function(e){e.preventDefault();
      var ci=opts.indexOf(data.colorOption);var v=current();if(ci<0||!v){return go(pair,false)}
      var items=[];data.colors.forEach(function(c){var t=sel.slice();t[ci]=c;var m=variants.find(function(x){return x.available&&x.options.every(function(o,i){return o===t[i]})});if(m)items.push({id:m.id,quantity:1})});
      if(items.length<2){setMsg('One of the colors is not available in this size right now.');return}
      go(pair,false,items);
    })}
    // sticky bar
    var sticky=document.querySelector('[data-tm-sticky]');var anchor=el.querySelector('[data-tm-actions]');
    if(sticky&&anchor&&'IntersectionObserver' in window){
      new IntersectionObserver(function(en){sticky.classList.toggle('is-on',!en[0].isIntersecting&&en[0].boundingClientRect.top<0)}).observe(anchor);
      var sb=sticky.querySelector('[data-tm-sticky-atc]');if(sb)sb.addEventListener('click',function(e){e.preventDefault();go(sb,false)});
    }
    render();
    try{var ac=el.querySelector('[data-tm-opt].is-active[data-media]');if(ac)showMedia(ac.dataset.media);}catch(e){}
  }

  /* ---------- stories ---------- */
  function initStories(){
    var viewer=null;var list=[];var idx=0;var timer=null;var start=0;var dur=5000;var raf=null;
    function build(){
      viewer=document.createElement('div');viewer.className='tm-sv';viewer.setAttribute('role','dialog');viewer.setAttribute('aria-modal','true');
      viewer.innerHTML='<div class="tm-sv__stage"><div class="tm-sv__bars"></div><div class="tm-sv__top"><span data-sv-label></span><button class="tm-sv__close" aria-label="Close">&times;</button></div><div data-sv-media></div><button class="tm-sv__nav tm-sv__nav--prev" aria-label="Previous"></button><button class="tm-sv__nav tm-sv__nav--next" aria-label="Next"></button><div class="tm-sv__bottom"><div class="tm-sv__cap" data-sv-cap></div><div class="tm-sv__price" data-sv-price></div><a class="tm-btn tm-btn--fire tm-btn--block" data-sv-buy href="#"><span data-sv-cta>Shop now</span><span class="tm-arrow">&rarr;</span></a></div></div>';
      document.body.appendChild(viewer);
      viewer.querySelector('.tm-sv__close').addEventListener('click',close);
      viewer.querySelector('.tm-sv__nav--prev').addEventListener('click',function(){show(idx-1)});
      viewer.querySelector('.tm-sv__nav--next').addEventListener('click',function(){show(idx+1)});
      viewer.addEventListener('click',function(e){if(e.target===viewer)close()});
      viewer.querySelector('[data-sv-buy]').addEventListener('click',function(e){
        var href=this.getAttribute('href')||'';var here=window.location.pathname;
        if(href.split('?')[0].split('#')[0]===here){e.preventDefault();close();var t=document.querySelector('[data-tm-actions]');if(t)t.scrollIntoView({behavior:'smooth',block:'center'});}
      });
      document.addEventListener('keydown',function(e){if(!viewer.classList.contains('is-open'))return;if(e.key==='Escape')close();if(e.key==='ArrowRight')show(idx+1);if(e.key==='ArrowLeft')show(idx-1)});
    }
    function tick(){
      var p=Math.min(1,(Date.now()-start)/dur);var bar=viewer.querySelectorAll('.tm-sv__bar i')[idx];if(bar)bar.style.width=(p*100)+'%';
      if(p>=1){show(idx+1);return}raf=requestAnimationFrame(tick);
    }
    function show(i){
      cancelAnimationFrame(raf);
      if(i<0)i=0; if(i>=list.length){close();return}
      idx=i;var s=list[i];
      viewer.querySelectorAll('.tm-sv__bar i').forEach(function(b,k){b.style.width=k<i?'100%':'0%'});
      var m=viewer.querySelector('[data-sv-media]');
      if(s.video){m.innerHTML='<video playsinline muted autoplay preload="auto" '+(s.poster?'poster="'+s.poster+'"':'')+' src="'+s.video+'"></video>';
        var v=m.querySelector('video');dur=8000;v.addEventListener('loadedmetadata',function(){if(v.duration&&isFinite(v.duration))dur=Math.min(v.duration*1000,20000)});var pp=v.play();if(pp&&pp.catch)pp.catch(function(){});}
      else{m.innerHTML='<img src="'+s.image+'" alt="">';dur=5000}
      viewer.querySelector('[data-sv-label]').textContent=s.label||'';
      viewer.querySelector('[data-sv-cap]').textContent=s.caption||'';
      viewer.querySelector('[data-sv-price]').textContent=s.price||'';
      var buy=viewer.querySelector('[data-sv-buy]');buy.setAttribute('href',s.url||'#');viewer.querySelector('[data-sv-cta]').textContent=s.cta||'Shop now';
      if(s.el)s.el.classList.add('is-seen');
      start=Date.now();raf=requestAnimationFrame(tick);
    }
    function open(group,i){
      if(!viewer)build();
      list=[].map.call(group.querySelectorAll('[data-tm-story]'),function(b){var d=JSON.parse(b.querySelector('script').textContent);d.el=b;return d});
      viewer.querySelector('.tm-sv__bars').innerHTML=list.map(function(){return '<div class="tm-sv__bar"><i></i></div>'}).join('');
      viewer.classList.add('is-open');document.documentElement.style.overflow='hidden';show(i);
    }
    function close(){if(!viewer)return;cancelAnimationFrame(raf);viewer.classList.remove('is-open');viewer.querySelector('[data-sv-media]').innerHTML='';document.documentElement.style.overflow='';}
    document.addEventListener('click',function(e){var b=e.target.closest('[data-tm-story]');if(!b)return;e.preventDefault();var g=b.closest('[data-tm-stories]');var all=[].slice.call(g.querySelectorAll('[data-tm-story]'));open(g,all.indexOf(b));});
  }

  /* ---------- track order ---------- */
  function initTrack(){
    document.querySelectorAll('[data-tm-track]').forEach(function(f){
      f.addEventListener('submit',function(e){e.preventDefault();var n=(f.querySelector('input').value||'').trim().replace(/\s+/g,'');
        var out=f.querySelector('[data-tm-track-msg]');
        if(!/^[A-Za-z0-9-]{6,40}$/.test(n)){out.textContent='Please enter a valid tracking number (letters and numbers only).';out.classList.add('is-on');return}
        out.classList.remove('is-on');window.open('https://t.17track.net/en#nums='+encodeURIComponent(n),'_blank','noopener');});
    });
  }

  function boot(){initReveal();initVideos();document.querySelectorAll('[data-tm-pdp]').forEach(initPDP);initStories();initTrack();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',function(e){initReveal(e.target);initVideos(e.target);e.target.querySelectorAll('[data-tm-pdp]').forEach(initPDP)});
})();

